import React from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import EstimateForm from '../components/EstimateForm';
import { Scale, ArrowLeft } from 'lucide-react';
import { slugsToProducts } from '../data/compareUtils';

const EstimatePage = () => {
  const [searchParams] = useSearchParams();
  const modelSlugs = (searchParams.get('models') || '').split(',').filter(Boolean);
  const shortlist = slugsToProducts(modelSlugs);

  return (
    <div className="min-h-screen">
      <Header />
      <main className="pt-24 pb-16 bg-gradient-to-br from-[#f8faf5] via-white to-[#f0f7e6]">
        <div className="max-w-2xl mx-auto px-4">
          {shortlist.length > 0 && (
            <div
              className="mb-5 bg-white rounded-2xl shadow-sm border border-[#B5D43B]/40 overflow-hidden"
              data-testid="estimate-shortlist-banner"
            >
              <div className="bg-gradient-to-r from-[#3D5A47] to-[#2a4032] px-5 py-3 flex items-center justify-between gap-3">
                <div className="flex items-center gap-2">
                  <Scale className="w-4 h-4 text-[#B5D43B]" />
                  <span className="text-white font-semibold text-sm">
                    Your shortlist · {shortlist.length} model{shortlist.length === 1 ? '' : 's'}
                  </span>
                </div>
                <Link
                  to="/compare"
                  className="text-[11px] text-white/80 hover:text-white inline-flex items-center gap-1"
                >
                  <ArrowLeft className="w-3 h-3" /> Edit
                </Link>
              </div>
              <div className="p-4 space-y-2">
                {shortlist.map((p) => (
                  <div
                    key={p.slug}
                    className="flex items-center gap-3 p-2 bg-gray-50 rounded-lg"
                    data-testid={`estimate-shortlist-item-${p.slug}`}
                  >
                    <img
                      src={p.image}
                      alt={p.name}
                      className="w-10 h-10 object-contain rounded bg-white flex-shrink-0"
                      loading="lazy"
                    />
                    <div className="flex-1 min-w-0">
                      <p className="text-sm font-semibold text-[#3D5A47] truncate">
                        {p.name.split(' (')[0]}
                      </p>
                      <p className="text-[11px] text-gray-400 font-mono truncate">{p.model}</p>
                    </div>
                  </div>
                ))}
                <p className="text-[11px] text-gray-500 mt-2 leading-relaxed">
                  Your selection will be sent with this enquiry so our team can quote these specific models for you.
                </p>
              </div>
            </div>
          )}

          <div className="bg-white rounded-2xl shadow-lg border border-gray-100 p-6 md:p-8">
            <EstimateForm
              isModal={false}
              shortlistModels={shortlist.length > 0 ? shortlist.map((p) => `${p.name} (${p.model})`).join('; ') : null}
            />
          </div>

          {/* Trust Badges */}
          <div className="mt-8 text-center">
            <p className="text-sm text-gray-500 mb-4">Trusted by thousands of Victorian homeowners</p>
            <div className="flex justify-center gap-6 flex-wrap">
              <div className="flex items-center gap-2 text-sm text-gray-600">
                <svg className="w-5 h-5 text-[#B5D43B]" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"/>
                </svg>
                <span>CEC Accredited</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-gray-600">
                <svg className="w-5 h-5 text-[#B5D43B]" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"/>
                </svg>
                <span>NETCC Approved</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-gray-600">
                <svg className="w-5 h-5 text-[#B5D43B]" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"/>
                </svg>
                <span>Solar Victoria Approved</span>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default EstimatePage;
